import React from 'react';
import '../css/WhyChooseUs.css';
import safetyImg from '../assets/safety.JPG'; // Aapka academy logo file

const WhyChooseUs = () => {
  const coreFeatures = [
    "Experienced & Certified Trainers (NEBOSH IGC & IDIP Qualified)",
    "100% Practical Training with Live Demonstrations",
    "Dedicated Placement Cell with Strong Job Assistance",
    "Only Gold Learning Partner of NEBOSH (UK) in Bihar, UP & Jharkhand",
    "16+ Years of Experience in Safety Training",
    "10,000+ Students Successfully Trained",
    "Industrial Site Visits & Real Industry Exposure",
    "International Placement Guidance (Gulf & Overseas Opportunities)"
  ];

  return (
    <section className="gfi-wcu-section">
      <div className="gfi-wcu-container">
        
        {/* LEFT BLOCK: CONTENT AND KEY BENEFIT POINTS */}
        <div className="gfi-wcu-content-side">
          <span className="gfi-wcu-mini-badge">WHY CHOOSE GROWTH ACADEMY ?</span>
          <h2 className="gfi-wcu-main-title">
            We Don't Just Train Students <br />— We Build Careers
          </h2>
          
          <ul className="gfi-wcu-features-list">
            {coreFeatures.map((feature, index) => (
              <li key={index} className="gfi-wcu-list-item">
                <span className="gfi-wcu-check-icon">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                </span>
                <span className="gfi-wcu-feature-text">{feature}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* RIGHT BLOCK: INDUSTRIAL MEDIA FRAMES WITH FLOATING CARD */}
        <div className="gfi-wcu-media-side">
          <div className="gfi-wcu-image-wrapper">
            {/* Random high-quality industrial safety live training image */}
          <img 
              src={safetyImg} 
              alt="Industrial Fire & Safety Live Practical Training" 
              className="gfi-wcu-main-img"
            />
            
            {/* Exact Overlapping Floating Badge Frame from Image 10 */}
            <div className="gfi-wcu-floating-badge">
              <div className="gfi-wcu-badge-num">16+</div>
              <div className="gfi-wcu-badge-label">
                YEARS OF <br />EDUCATIONAL <br />EXCELLENCE
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default WhyChooseUs;